import { Component, Input } from '@angular/core';

@Component({
  selector: 'ca-avatar-stack',
  templateUrl: './avatar-stack.component.html',
  styleUrls: ['avatar-stack.component.scss'],
})
export class AvatarStackComponent {
  @Input()
  avatars: Array<{ fullName: string; image: string }>;

  @Input()
  maxAvatars = 4;

  @Input()
  size: 'small' | 'large' = 'large';
}
